import React, { Component } from 'react';
import PropTypes from 'prop-types';


class Button extends Component {
	constructor(props) {
		super(props);

		this.getClass = this.getClass.bind(this);
	}
	getClass() {
		let cls = "button";

		if (!this.props.enabled) {
			cls += " disabled";
		}

		return cls;
	}
	render() {
		return (
			<div id={this.props.id}
				className={this.getClass()}
				onClick={this.props.enabled ? this.props.onClick : null}
			>
				{this.props.children}
			</div>
		);
	}
}

Button.propTypes = {
	children: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	id: PropTypes.string,
	enabled: PropTypes.bool
};

Button.defaultProps = {
	enabled: true,
};

export default Button;


// WEBPACK FOOTER //
// ./src/components/Button.js